import { render, staticRenderFns } from "./SetScope.vue?vue&type=template&id=aaa801ca&scoped=true&"
import script from "./SetScope.vue?vue&type=script&lang=js&"
export * from "./SetScope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa801ca",
  null
  
)

export default component.exports